import React from 'react';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
};

export const Button = ({ children, ...rest }: ButtonProps) => (
  <button
    {...rest}
    className="bg-accent text-2xl font-bold py-4 px-12 text-accent self-center tracking-wide"
  >
    {children}
  </button>
);
